'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var kzds = _interopDefault(require('@kuaizhan/kz-ds'));

var encodeQueryString = function encodeQueryString(obj) {
  var pairs = [];
  Object.keys(obj).forEach(function (key) {
    return pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
  });
  return pairs.join('&');
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var checkConf = function checkConf(conf) {
  var checkArr = ['api_prefix_v1', 'api_prefix_v2', 'api_prefix_v3', 'host'];
  checkArr.forEach(function (item) {
    if (conf[item] === undefined) {
      throw new Error("conf\u6587\u4EF6\u4E0D\u5B8C\u6574, \u7F3A\u5C11" + item);
    }
  });
};

var dsGroups = function dsGroups(ds, conf) {
  checkConf(conf); // 定义接口组v1

  ds.registerGroup('v1', {
    urlPrefix: conf.host + conf.api_prefix_v1,
    requestProcessor: function requestProcessor(req) {
      if (req.body) {
        if (!req.headers) {
          req.headers = {};
        }

        if (!req.headers['Content-Type'] && !(req.body instanceof FormData)) {
          req.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
          req.body = encodeQueryString(req.body);
        } else if (req.headers['Content-Type'] === 'application/json') {
          req.body = JSON.stringify(req.body);
        }
      }

      return req;
    },
    responseProcessor: function responseProcessor(res) {
      if (res.body && typeof res.body === 'string') {
        try {
          res.body = JSON.parse(res.body);
        } catch (e) {
          throw new Error('网络请求失败');
        }
      }

      return res;
    }
  }); // 注册v2接口组

  ds.registerGroup('v2', {
    urlPrefix: conf.host + conf.api_prefix_v2,
    requestProcessor: function requestProcessor(req) {
      if (req.body) {
        if (!req.headers) {
          req.headers = {};
        }

        if (!req.headers['Content-Type'] && !(req.body instanceof FormData)) {
          req.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
          req.body = encodeQueryString(req.body);
        } else if (req.headers['Content-Type'] === 'application/json') {
          req.body = JSON.stringify(req.body);
        }
      }

      return req;
    }
  }); // 注册v3接口组

  ds.registerGroup('v3', {
    urlPrefix: conf.host + conf.api_prefix_v3,
    requestProcessor: function requestProcessor(req) {
      if (req.body) {
        if (!req.headers) {
          req.headers = {};
        }

        if (!req.headers['Content-Type'] && !(req.body instanceof FormData)) {
          req.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
          req.body = encodeQueryString(req.body);
        } else if (req.headers['Content-Type'] === 'application/json') {
          req.body = JSON.stringify(req.body);
        }
      }

      return req;
    },
    responseProcessor: function responseProcessor(res) {
      return _extends({}, res, {
        data: res.body
      });
    }
  });
};

var passportApis = function passportApis(ds) {
  ds.register('v1/passport.login', {
    method: 'post',
    url: '/passport/ajax-login'
  });
  ds.register('v2/vcode.get', {
    method: 'get',
    url: '/passport/vcode'
  });
  ds.register('v2/passport.login', {
    method: 'post',
    url: '/passport/login'
  });
  ds.register('v1/passport.getNotices', {
    method: 'get',
    url: '/passport/ajax-get-notices'
  });
  ds.register('v1/passport.setNoticesRead', {
    method: 'post',
    url: '/passport/ajax-set-user-notice'
  });
};

var userApis = function userApis(ds) {
  ds.register('v2/user.get-info', {
    method: 'get',
    url: '/users/get-info'
  });
};

var dsConf = function dsConf(conf) {
  var ds = kzds.create();
  dsGroups(ds, conf);
  passportApis(ds);
  userApis(ds);
  return ds;
};

exports.dsConf = dsConf;